import React, { memo, useContext } from 'react'
import { Typography } from '@mui/material'
import { ShipmentMajor } from '@shopify/polaris-icons'
import { ContractorsTableContext } from '../contractors-table/ContractorsTable.context'
import { TableSelect } from 'src/components/shared/table/TableSelect'
import { vehicleFormTypes } from 'src/constants/vehicle'
import { colors } from 'src/theme'

export const NO_VEHICLE_FILTER_VALUE = 'no_vehicle'

const vehicleTypeOptions: Array<{ value: string; component: React.ReactNode }> = [
  {
    value: NO_VEHICLE_FILTER_VALUE,
    component: <Typography variant="subtitle1">No vehicle</Typography>,
  },
  ...vehicleFormTypes.map((vehicleFormType) => {
    return {
      value: vehicleFormType.value,
      component: <Typography variant="subtitle1">{vehicleFormType.label}</Typography>,
    }
  }),
]

const ContractorVehicleTypeSelectComponent = () => {
  const { vehicleTypeFilter, setVehicleTypeFilter } = useContext(ContractorsTableContext)

  return (
    <TableSelect<string>
      title="Vehicle Type"
      icon={<ShipmentMajor width={20} fill={colors.GRAY_BLACK} />}
      options={vehicleTypeOptions}
      selectedValues={vehicleTypeFilter}
      onSelect={setVehicleTypeFilter}
      triggerDataTestId="contractors-list-main-vehicle-type-menu-btn"
      clearAllDataTestId="contractors-list-main-vehicle-type-clear-all"
    />
  )
}

export const ContractorVehicleTypeSelect = memo(ContractorVehicleTypeSelectComponent)
